import { Route } from "react-router";
import { VerificationEmailSent } from "@/pages";
import React from "react";

/**
 * Route definitions for secure general routes.
 * Includes email verification flow which requires user authentication.
 */
export const secureGeneralRoutes: React.ReactElement[] = [
  <Route
    key="verification-email"
    path="/verification-email"
    element={<VerificationEmailSent />}
  />,
];
